import { all } from 'redux-saga/effects';
import { ADVSaga } from './advertisment/saga';
export default function* rootSaga(getState: any): any{
    yield all([
    ADVSaga()
    ]);

}
